




































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { batchDownloadSchemePlans, getSchemeOptions, getSchemePlanList, SchemeOptionItem, SchemePlanItem } from '../api/scheme/index';

type QueryForm = {
  industryCode: string;
  productCategoryCode: string;
};

@Component({
  components: {},
})
export default class SchemeCenter extends Vue {
  loading = false;
  downloadLoading = false;
  total = 0;
  planList: SchemePlanItem[] = [];
  selectedPlanSnList: string[] = [];
  industryOptions: SchemeOptionItem[] = [];
  productOptions: SchemeOptionItem[] = [];
  queryForm: QueryForm = {
    industryCode: '',
    productCategoryCode: '',
  };

  get isAllSelected() {
    return this.planList.length > 0 && this.selectedPlanSnList.length === this.planList.length;
  }

  get isIndeterminate() {
    return this.selectedPlanSnList.length > 0 && this.selectedPlanSnList.length < this.planList.length;
  }

  get downloadDisabled() {
    return this.downloadLoading || this.selectedPlanSnList.length === 0;
  }

  async mounted() {
    await this.fetchOptions();
    await this.fetchPlanList();
  }

  async fetchOptions() {
    try {
      const res = await getSchemeOptions();
      this.industryOptions = Array.isArray(res && res.industryList) ? res!.industryList : [];
      this.productOptions = Array.isArray(res && res.productList) ? res!.productList : [];
    } catch (error) {
      this.industryOptions = [];
      this.productOptions = [];
    }
  }

  buildQueryParams() {
    const data: QueryForm = {
      industryCode: this.queryForm.industryCode,
      productCategoryCode: this.queryForm.productCategoryCode,
    };
    return data;
  }

  async fetchPlanList() {
    this.loading = true;
    try {
      const res = await getSchemePlanList(this.buildQueryParams());
      this.planList = Array.isArray(res && res.list) ? res!.list : [];
      this.total = Number((res && res.total) || this.planList.length || 0);
      this.selectedPlanSnList = this.selectedPlanSnList.filter(sn => this.planList.some(item => item.sn === sn));
    } catch (error) {
      this.planList = [];
      this.total = 0;
      this.selectedPlanSnList = [];
    } finally {
      this.loading = false;
    }
  }

  handleSearch() {
    this.fetchPlanList();
  }

  isSelected(sn: string) {
    return this.selectedPlanSnList.includes(sn);
  }

  handleItemCheck(sn: string, checked: boolean) {
    if (checked) {
      if (!this.selectedPlanSnList.includes(sn)) {
        this.selectedPlanSnList = [...this.selectedPlanSnList, sn];
      }
      return;
    }
    this.selectedPlanSnList = this.selectedPlanSnList.filter(item => item !== sn);
  }

  handleToggleAll(checked: boolean) {
    this.selectedPlanSnList = checked ? this.planList.map(item => item.sn) : [];
  }

  handlePreview(url: string) {
    if (!url) {
      this.$message.warning('预览地址不存在');
      return;
    }
    window.open(url, '_blank');
  }

  async handleBatchDownload() {
    if (!this.selectedPlanSnList.length) {
      this.$message.warning('请先勾选方案');
      return;
    }
    this.downloadLoading = true;
    try {
      await batchDownloadSchemePlans(this.selectedPlanSnList);
    } catch (error) {
      this.$message.error((error && (error as Error).message) || '下载失败');
    } finally {
      this.downloadLoading = false;
    }
  }
}
